import { render } from "./OrgAdminList.vue?vue&type=template&id=839a5cca&scoped=true"
import script from "./OrgAdminList.vue?vue&type=script&lang=js"
export * from "./OrgAdminList.vue?vue&type=script&lang=js"

import "./OrgAdminList.vue?vue&type=style&index=0&id=839a5cca&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-839a5cca"]])

export default __exports__